/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InitValues model module.
 * @module model/InitValues
 * @version 1.0.0
 */
class InitValues {
    /**
     * Constructs a new <code>InitValues</code>.
     * @alias module:model/InitValues
     */
    constructor() { 
        
        InitValues.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InitValues</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InitValues} obj Optional instance to populate.
     * @return {module:model/InitValues} The populated <code>InitValues</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InitValues();

            if (data.hasOwnProperty('serverVersion')) {
                obj['serverVersion'] = ApiClient.convertToType(data['serverVersion'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InitValues</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InitValues</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['serverVersion'] && !(typeof data['serverVersion'] === 'string' || data['serverVersion'] instanceof String)) {
            throw new Error("Expected the field `serverVersion` to be a primitive type in the JSON string but got " + data['serverVersion']);
        }

        return true;
    }


}



/**
 * @member {String} serverVersion
 */
InitValues.prototype['serverVersion'] = undefined;






export default InitValues;

